module.exports = __webpack_public_path__ + "media/categories/64-008e787f.png";